import React, { useState } from "react";
import MidBox from "../../../components/Boxes/MidBox";
import { motion } from "framer-motion";
import Button from "../../../components/Button";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useNavigate, useSearchParams } from "react-router-dom";
import Share from "../../../components/Share";
import { useAppTranslation } from "../../../i18n/useAppTranslation";

type Props = {};

// TODO: connect to backend

const HOST_URL = "/arena/join-match";

const FriendlyMatchBox = (props: Props) => {
  const [isCopied, setIsCopied] = React.useState(false);
  const { t } = useAppTranslation(["battle", "common"]);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const [isShareOpen, setIsShareOpen] = useState(false);
  const link = window.location.origin + HOST_URL + "?id=" + id;
  const onCopy = () => {
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 1000);
  };
  return (
    <motion.div
      initial={{ maxWidth: 0, opacity: 0 }}
      animate={{ opacity: 1, maxWidth: 450 }}
      className="mx-auto overflow-hidden"
      transition={{ duration: 0.3, delay: 0.1 }}
    >
      <MidBox
        noMargin
        style={{ maxWidth: 450, opacity: 0.95 }}
        title={t("friendlyMatch.title")}
        className="mx-auto "
        closeAble
        onClose={() => navigate("/home")}
      >
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
          className="d-flex gap-2 flex-column  justify-content-center "
        >
          <ul>
            <li>{t("friendlyMatch.instructions.create")}</li>
            <li>{t("friendlyMatch.instructions.share")}</li>
            <li className="bold">{t("friendlyMatch.instructions.referral")}</li>
          </ul>
          <div>
            <span>{t("friendlyMatch.linkLabel")}</span>
            <OverlayTrigger
              overlay={
                <Tooltip id={`tooltip-${"top"}`}>
                  {isCopied ? (
                    <span className="text-success-light">
                      {t("friendlyMatch.copiedSuccess")}
                    </span>
                  ) : (
                    <>{t("friendlyMatch.copyToClipboard")}</>
                  )}
                </Tooltip>
              }
            >
              <CopyToClipboard onCopy={onCopy} text={link}>
                <div className="bg-3 link-border pointer p-2  fs-small rounded-4 gap-2 d-flex bg-2 align-items-center justify-content-center">
                  {link}
                </div>
              </CopyToClipboard>
            </OverlayTrigger>
          </div>

          <div className="d-flex mt-3 align-items-center justify-content-center">
            <CopyToClipboard onCopy={onCopy} text={link}>
              <Button variant="default" className="bg-100">
                {t("common:actions.copy")}
              </Button>
            </CopyToClipboard>
            <Button
              onClick={() => setIsShareOpen(true)}
              variant="primary"
              className="bg-100"
            >
              {t("friendlyMatch.share")}
            </Button>
          </div>
        </motion.div>
      </MidBox>
      <Share
        shareNote={t("friendlyMatch.shareNote")}
        open={isShareOpen}
        onClose={() => setIsShareOpen(false)}
        link={link}
      />
    </motion.div>
  );
};

export default FriendlyMatchBox;
